import React from 'react';
import styles from "../../styles/customer/CustomerPartner.module.css";

const CustomerPartner = () => {
  return (
    <section className={styles.hero}>
      <div className={styles.overlay} />

      <div className={styles.container}>
        <div className={styles.panel}>
          <h1 className={styles.heading}>비즈니스 협력</h1>

          <p className={styles.text}>
            ㈜메타에이아이(Meta AI)는 인공지능 모델링과 데이터 기반 컨설팅을 중심으로,
            기업과 기관의 경쟁력을 높이는 AI 솔루션 전문 기업입니다. AI 기술을 현장에
            효과적으로 적용하기 위한
          </p>

          <div className={styles.featureList}>
            <div className={styles.featureItem}>
              <span className={styles.badge}>1</span>
              <span className={styles.featureText}>맞춤형 인공지능 컨설팅 및 모델 개발</span>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.badge}>2</span>
              <span className={styles.featureText}>실무 중심의 인공지능 교육 프로그램</span>
            </div>
            <div className={styles.featureItem}>
              <span className={styles.badge}>3</span>
              <span className={styles.featureText}>신뢰할 수 있는 AI 기반 보안 솔루션</span>
            </div>
          </div>

          <p className={styles.text}>
            을 제공하며, 고객의 비즈니스와 교육 환경에 최적화된 AI 가치를 실현합니다.
            ㈜메타에이아이와의 협업, 서비스 도입, 공동 프로젝트를 희망하시는 분께서는
            비즈니스협력이 필요한 내용을 정리하여{" "}
            <a className={styles.mailInline} href="mailto:metaai@naver.com">
              metaai@naver.com
            </a>{" "}
            으로 보내주시면 담당자가 빠르고 친절하게 안내드리겠습니다.
          </p>
        </div>
      </div>
    </section>
  )
}

export default CustomerPartner